<template>
  <div>
    <HeaderBreadcrumbs
			:items="[{
					label: 'Banner',
					to:''
				},
			]"
			title="All Banner"
		/>
    <div class="flex justify-between py-3 px-4 bg-white">
      <div class="relative">
                    <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                    <input class="bg-white rounded-lg py-2 px-11 border w-96"
                        placeholder='Search Banner Name' v-model="query_search" @input="asyncFind" />
                    <button v-if="query_search"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>
                </div>
                <div class="relative flex justify-end">
                  <button
            class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
            type="button">
            <router-link class="text-white px-1 py-2" :to="{ name: BannersAddPath.name }">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </button>

             <t-dropdown>
            <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
              class="flex">
              <button
                class="flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
                <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                </svg>
                Filter
                <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <polygon
                    points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
                </svg>
                  <div v-if="dataBadge"
                  class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
                  {{ dataBadge }}
                </div>
              </button>
            </div>
            <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
              slot-scope="{ hide, blurHandler }">
              <div
                class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
                role="menuitem">
                <div class="flex justify-between mb-3 mt-2">
                  <div>Filter</div>
                  <div @click="hide">
                    <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                  </div>
                </div>
                <div class="grid gap-4 grid-cols-2">
                  <div>
                    <label class="text-gray-600 font-semibold mb-3">Platform</label>
                    <PlatformFilter v-model="platformType" class="capitalize" :options="PlatfromtypeOptions"
                      :defaultText="'Select Platform'" />
                  </div>


                  <div>
                    <label class="text-gray-600 font-semibold mb-3">Banner Type</label>
                      <BannersTypeFilter
                      v-model="bannerType"
                      :options="bannersTypeOptions"
                      :defaultText="`Select Banner Type`"
                       />
                    </div>
                </div>
                <div class="mt-3">
                  <button class="border bg-blue-700 px-4 py-2 text-white rounded-lg" @click="asyncFind"
                    @blur="blurHandler">
                    Filter
                  </button>
                  <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="asyncClearFind()"
                    @blur="blurHandler">Reset</button>
                </div>
              </div>
            </div>
          </t-dropdown>
                </div>                
    </div>
    <Table
    :headers="headers"
      :data="items"
      :row-key="['name', 'client_id', 'banner_type', 'valid_from', 'valid_to']"
      :current-page="currentPage"
      :isLoading="isLoading"
      :per-page="perPage">
      <template #header-create="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <template #header-modified="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
      <template #client_id="{ value}">
       
          <span :class="statusColorClient(value)"  class="capitalize">
            {{platform( value.toString())}}
          </span>
        </template>
        <template #banner_type="{ value }">
          <span :class="BannerTypeColor(value)" class="capitalize">
            {{value}}
          </span>
        </template>
        <template #valid_from="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #valid_to="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        
        <template #actions="{ row }">
          <router-link :to="{ path: 'banner-detail/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>
          </router-link>
          </template>
    </Table>
        <div v-if="!isLoading && items.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { BannersAddPath } from "../../router/marketing";
import PlatformFilter from '@/components/form/StatusFilterComponent.vue'
import BannersTypeFilter from '@/components/form/StatusFilterComponent.vue'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs.vue';
//import TableBanners from "../../components/banners/banners.vue";
import moment from 'moment';

import Table from '../../components/form/table.vue'
export default {
  name: 'banners',
  components:{
   // TableBanners,
    PlatformFilter,
    BannersTypeFilter,
    HeaderBreadcrumbs,
    Table
  },
  data() {
    return {
      BannersAddPath,
      currentPage: 1,
      dataBadge: null,
      sortOrder: 'desc',
      perPage: 15,
      bannersTypeOptions: [
        { value: 'all', text: 'All Status' },
        { value: 'banner only', text: 'Banner Only' },
        { value:'buffet', text:'Buffet'},
        { value:'landing page', text:'Landing Page'},
        { value:'open url', text:'Open Url'},
        { value:'promo', text:'Promo'},
        { value:'static', text:'Static'},
      ],
      PlatfromtypeOptions: [
        { value: 'all-type', text: 'All Type' },
        { value: 'android', text: 'Android' },
        { value:'ios', text:'IOS'},
        { value:'web', text:'Webstore'},
      ],
      
      platformType:null,
      filterPlatfrom:null,
      bannerType:null,
      headers: [
        { label: 'No', key: 'no' },
        { label: 'banner name', key: '' },
        { label: 'platform', key: '' },
        { label: 'banner type', key: '' },
        { label: 'Created Date', key: 'valid_from',sortable: true, slotHeader: 'header-create' },
        { label: 'Last Modified', key: 'valid_to',sortable: true, slotHeader: 'header-modified' },
      ],
			query_search: '',
      isLoadingSearch: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Banner | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
   // ...mapGetters("banners", ["banners"]),
    ...mapState({
      isLoading: (state) => state.banners.isLoading,
      isError: (state) => state.banners.isError,
      totalRows: (state) => state.banners.totalRows,
      items: (state) => state.banners.items,
    }),
  },
  created() {
    this.actionGetBaners();
  },
  methods: {
    ...mapActions('banners', ['fetchBanners','fetchBannersByid','searchBanners']),
    actionGetBaners() {
        let payload = {
					page:this.currentPage,
					limit: this.perPage,
          platform: this.platformType,
          bannertype:this.bannerType,
          keyword:this.query_search
				};
			this.fetchBanners(payload);
    },
      async  onClickPage(page) {
      this.currentPage = page;
      this.actionGetBaners();
    },
     filterBadge() {
      let badgeCount = 0;
      if (this.platformType != null) badgeCount += 1;
      if (this.bannerType != null) badgeCount += 1;
      
      this.dataBadge = badgeCount > 0 ? badgeCount : null;
    },
  platform(key) {

    const platformClientMap = {
      android: 2,
      ios: 1,
      web: 7
    };

    const platformNameMap = {
      1: 'IOS',
      2: 'Android',
      7: 'Web Store'
    };

    const expectedId = platformClientMap[this.filterPlatfrom];
    const expectedStr = String(expectedId);

    let match = null;

    if (typeof key === 'string') {
      const parts = key.split(',').map(str => str.trim());
      match = parts.find(id => id === expectedStr) || 7;
    }

    const keyNum = Number(key);
    const matchNum = Number(match);

    if (keyNum === 1 || matchNum === 1) {
      return platformNameMap[1];
    } else if (keyNum === 2 || matchNum === 2) {
      return platformNameMap[2];
    } else if (keyNum === 7 || matchNum === 7) {
      return platformNameMap[7];
    }

    return null;
  },
    
  
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
      sortBy(sortByCreate) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      let payload = {
          page:this.currentPage,
					limit: this.perPage,
          platform: this.platformType,
          bannertype:this.bannerType,
          order_by:sortByCreate,
          sort:this.sortOrder
      };

      this.fetchBanners(payload);
    },

  statusColorClient(status) {
    const platformClientMap = {
      android: 2,
      ios: 1,
      web: 7
    };

    const expectedId = platformClientMap[this.filterPlatfrom];
    const expectedStr = String(expectedId);

    let match = null;

    if (Array.isArray(status)) {
      const matchStr = status.map(s => String(s)).find(s => s === expectedStr);
      match = matchStr ? Number(matchStr) : null;
    } else if (typeof status === 'number') {
      match = status === expectedId ? status : 7;
    }

    const valueToCheck = match ?? (Array.isArray(status) ? status[0] : status);
    switch (valueToCheck) {
      case 7:
        return 'bg-blue-100 text-blue-700 capitalize text-xs px-2.5 py-1 rounded-lg';
      case 1:
        return 'bg-yellow-100 text-yellow-700 capitalize text-xs px-2.5 py-1 rounded-lg';
      case 2:
        return 'bg-green-200 text-green-800 capitalize text-xs px-2.5 py-1 rounded-lg';
      default:
        return 'bg-gray-100 text-gray-700 capitalize text-xs px-2.5 py-1 rounded-lg';
  }
}, 

  BannerTypeColor(status) {
  const normalizedStatus = String(status).trim().toLowerCase(); // normalisasi dulu
  switch (normalizedStatus) {
    case 'banner only':
      return 'bg-gray-100 text-gray-700 text-xs px-2.5 py-1 rounded-lg';
    case 'open url':
      return 'bg-yellow-100 text-yellow-700 text-xs px-2.5 py-1 rounded-lg';
    case 'landing page':
      return 'bg-green-200 text-green-800 text-xs px-2.5 py-1 rounded-lg';
    case 'static':
      return 'bg-purple-200 text-purple-800 text-xs px-2.5 py-1 rounded-lg';
    case 'promo':
      return 'bg-blue-200 text-blue-800 text-xs px-2.5 py-1 rounded-lg';
    case 'brand':
      return 'bg-gray-700 text-gray-100 text-xs px-2.5 py-1 rounded-lg';
    case 'buffet':
      return 'bg-red-200 text-red-800 text-xs px-2.5 py-1 rounded-lg';
    default:
      return 'bg-gray-200 text-gray-800 text-xs px-2.5 py-1 rounded-lg';
  }
},
		setQuerySearch(query) {
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				this.query_search = query;
			}, 1000);
		},
    actionReset() {
      this.query_search = null
      this.actionGetBaners();
      this.dataBadge = null
    },
    asyncFind() {
			this.isLoadingSearch = true;
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				const query = this.query_search;
           this.currentPage = 1
					this.isLoadingSearch = false;
           let payload = {
					page:this.currentPage,
					limit: this.perPage,
          platform: this.platformType,
          bannertype:this.bannerType,
          keyword:query
				};
			this.fetchBanners(payload);
      this.filterBadge()
      this.filterPlatfrom = this.platformType
        return;
			}, 1000);
    },
		asyncClearFind() {
			this.query_search = null;
      this.platformType = null
      this.bannerType = null
      this.dataBadge = null
      this.currentPage = 1
      this.actionGetBaners();
    
		},
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
  },
};
</script>
<style lang="postcss">
.w-custom {
  width: 620px;
}
</style>